import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesPrioritiesEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-priorities-edit',
	path: '/secure/admin/EditPriority!default.jspa',
};
